import { render, staticRenderFns } from "./SettingsCategoryTypeDetails.vue?vue&type=template&id=0b712956&scoped=true&"
import script from "./SettingsCategoryTypeDetails.vue?vue&type=script&lang=ts&"
export * from "./SettingsCategoryTypeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b712956",
  null
  
)

export default component.exports